import React, { useState, FC } from "react"
import { Modal } from "@bancacfplus/Modal"
import { CompleteConsents } from "./CompleteConsents"
import { useUserConsents } from "./hooks/useUserConsents"
import { ErrorBoundaryEnriched } from "../ErrorBoundaryEnriched"
import { labels } from "./data/labels"
import style from "./GdprConsents.module.scss"

type GdprConsentsProps = {
  email: string
}

export const GdprConsents: FC<GdprConsentsProps> = ({ email }) => {
  const { isUserWithoutConsents, error, isError, isLoading } = useUserConsents(email)
  const [toggleModal, setToggleModal] = useState<boolean>(!isError)

  if (isLoading) {
    return <></>
  }

  if (isError) {
    return <ErrorBoundaryEnriched error={error} swallow />
  }

  return (
    <>
      {/* User not found in preferences repository, ask for consents */}
      {isUserWithoutConsents && (
        <Modal close="dark" hash={false} type="cta" opened={toggleModal} className={style.gdprModal} id="gdpr-consents">
          <CompleteConsents
            email={email}
            closeConsents={() => setToggleModal(false)}
            collapsed
            title={labels.header}
            submitLabel={labels.submitLabel}
            consents={undefined}
          />
        </Modal>
      )}
    </>
  )
}
